import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thSeperator',
})
export class ThSeperatorPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): any {
    let str = value?.toString();
    let base,
      dec = '';
    if (str && str.includes('.')) {
      str = Number(str).toFixed(2);
      base = this.separator(str.split('.')[0]);
      dec = str.split('.')[1];
      return base + '.' + dec;
    } else {
      base = this.separator(str);
      return base;
    }
  }

  separator = (str: string): any => {
    if(!str) return '';
    if (str.length <= 3) return str;
    return (
      this.separator(str.substring(0, str.length - 3)) +
      ',' +
      str.slice(str.length - 3)
    );
  };
}
